import { motion } from "motion/react";
import { SectionHeader } from "@/theme1/components/common/SectionHeader";

export default function ApparelLifestyleGallery({ gallery }) {
  // 🛡️ Ensure gallery is an array
  const galleryItems = Array.isArray(gallery) ? gallery : [];
  
  // If no gallery items, return null or a placeholder
  if (galleryItems.length === 0) {
    return (
      <section className="py-20 sm:py-24 lg:py-32">
        <SectionHeader
          eyebrow="The apparel journal"
          title="Designed for the pace of everyday life."
          description="An editorial study of proportion, texture, and modern uniform dressing."
        />
        <div className="mt-12 text-center text-muted-foreground">
          <p>Gallery coming soon...</p>
        </div>
      </section>
    );
  }

  return (
    <section className="py-20 sm:py-24 lg:py-32">
      <SectionHeader
        eyebrow="The apparel journal"
        title="Designed for the pace of everyday life."
        description="An editorial study of proportion, texture, and modern uniform dressing."
      />

      <div className="mt-12 grid gap-5 lg:grid-cols-2">
        {galleryItems.map((item, index) => (
          <motion.figure
            key={item.id || index}
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-50px" }}
            transition={{ duration: 0.6, delay: index * 0.07 }}
            className={`group relative overflow-hidden rounded-[2rem] bg-neutral-100 ${
              item.size === "large"
                ? "min-h-[460px] sm:min-h-[580px]"
                : "min-h-[380px] sm:min-h-[480px]"
            }`}
          >
            <img
              src={item.image}
              alt={item.alt || item.label || 'Gallery image'}
              loading="lazy"
              className="absolute inset-0 size-full object-cover transition duration-1000 group-hover:scale-105"
            />

            <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/10 to-transparent" />

            <figcaption className="absolute inset-x-0 bottom-0 p-6 text-white sm:p-8">
              <p className="text-xs font-black uppercase tracking-[0.28em] text-white/65">
                Captex Editorial
              </p>
              <h3 className="mt-3 text-3xl font-black uppercase tracking-tight sm:text-4xl">
                {item.label}
              </h3>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </section>
  );
}